import { offlineDatabase } from '../database/offlineDatabase/offlineDatabase';
import { createOfflineCommonRepository } from './common/createOfflineCommonRepository';

export const offlineSellersRepository = createOfflineCommonRepository(
  () => offlineDatabase.sellers,
  ['name'],
);
